import { select } from "d3-selection";
import { transition } from "d3-transition";
import { default as attrize } from "./attrize.js";
/**
    Manages the enter/update/exit pattern for a single DOM element, applying enter, update, and exit attributes with optional transitions.
    @param selector A CSS selector string for the element tag and classes.
    @param p Configuration object with enter, exit, update, and parent options.
*/ export default function(selector, p) {
    // overrides default params
    var params = Object.assign({}, {
        condition: true,
        enter: {},
        exit: {},
        duration: 0,
        parent: select("body"),
        update: {}
    }, p);
    var className = /\.([^#]+)/g.exec(selector), id = /#([^.]+)/g.exec(selector), t = transition().duration(params.duration), tag = /^([^.^#]+)/g.exec(selector)[1];
    var elem = params.parent.selectAll(selector.includes(":") ? selector.split(":")[1] : selector).data(params.condition ? [
        null
    ] : []);
    var enter = elem.enter().append(tag).call(attrize, params.enter);
    if (id) enter.attr("id", id[1]);
    if (className) enter.attr("class", className[1]);
    if (params.duration) elem.exit().transition(t).call(attrize, params.exit).remove();
    else elem.exit().call(attrize, params.exit).remove();
    var update = enter.merge(elem);
    if (params.duration) update.transition(t).call(attrize, params.update);
    else update.call(attrize, params.update);
    return update;
}

//# sourceMappingURL=elem.js.map